import { Box, Button, Grid, TextField, Typography, useMediaQuery } from "@mui/material";

import React, { useEffect, useState } from "react";
import { useAddSmsReminderSettingForm, useAddSmsResultForWinnerSettingForm, useAddSmsResultSettingForm, useAddSmsSettingForm } from "../../utils/forms";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getAllSmsSettings } from "../../service/SmsSettingService";

interface ChipData {
  linkSmsContent: string;
  reminderSmsContent: string;
  _id: string;
}
export default function SmsSetting() {
  const [data, setData] = React.useState<ChipData[]>([]);
  const [isDelete, setIsDelete] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [id, setId] = useState("");
  const isMobile = useMediaQuery("(max-width:600px)");
  const formikLinkSMS = useAddSmsSettingForm(isEdit, id, isMobile);
  const formikReminderSms = useAddSmsReminderSettingForm(isEdit, id, isMobile);
  const formikResultSms = useAddSmsResultSettingForm(isEdit, id, isMobile);
  const formikResultSmsForWinner = useAddSmsResultForWinnerSettingForm(isEdit, id, isMobile);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();

  const [isEditing, setIsEditing] = useState(false);
  const [isReminderEditing, setIsReminderEditing] = useState(false);
  const [isResultSmsEditing, setIsResultSmsEditing] = useState(false);
  const [isResultSmsForWinnerEditing, setIsResultSmsForWinnerEditing] = useState(false);
  const [t] = useTranslation("global");

  const smsVariables = [
    { key: 'FIRSTNAME', description: "User's first name" },
    { key: 'LASTNAME', description: "User's last name" },
    { key: 'EMAIL', description: "User's email" },
    { key: 'PHONE', description: "User's phone number" },
    { key: 'LINK', description: "Breef link" },
    { key: 'BREEFEXPIRYDATE', description: "Breef expiry date" },
    { key: 'BREEFSTARTDATE', description: "Breef start date" },
    { key: 'TENANTFIRSTNAME', description: "Tenant's first name" },
    { key: 'TENANTLASTNAME', description: "Tenant's last name" },
    { key: 'USERPLACEMENT', description: "User's placement" },
    { key: 'BREEFSCORE', description: "Breef score" },
    { key: 'USERSCORE', description: "User's score" },
    { key: 'BREEFNAME', description: "Breef name" },
    { key: 'PRICE', description: "Breef price" },
    { key: 'NUMBEROFPARTICIPANTS', description: "Number of participants" },
  ];

  const handleCancel = () => {
    setIsEditing(false);
  };
  const handleReminderSmsCancel = () => {
    setIsReminderEditing(false);
  };

  const handleReminderSmsOpenEdit = () => {
    setIsReminderEditing(true);
  };
  const handleOpenEdit = () => {
    setIsEditing(true);
  };

  const handleResultSmsOpenEdit = () => {
    setIsResultSmsEditing(true);
  };
  const handleResultSmsCancel = () => {
    setIsResultSmsEditing(false);
  };
  const handleResultSmsForWinnerOpenEdit = () => {
    setIsResultSmsForWinnerEditing(true);
  };
  const handleResultSmsForWinnerCancel = () => {
    setIsResultSmsForWinnerEditing(false);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    setId(data[0]?._id.toString());
    setIsEdit(true);
    e.preventDefault();
    console.log("Entered here", formikReminderSms.values);
    console.log("Entered here", isReminderEditing);

    if (isReminderEditing) {
      const reminderResponse = await formikReminderSms.submitForm();
      console.log("reminderResponse", reminderResponse);
    } else if (isEditing) {
      const linkResponse = await formikLinkSMS.submitForm();
      console.log("linkResponse", linkResponse);
      // setIsLinkSmsEdit(false);
    }
    else if (isResultSmsEditing) {
      const resultResponse = await formikResultSms.submitForm();
      console.log("resultResponse", resultResponse);
    }
    else{
      const resultResponse = await formikResultSmsForWinner.submitForm();
      console.log("resultResponse", resultResponse);
    }
    setIsReminderEditing(false);
    setIsResultSmsEditing(false);
    setIsEditing(false);
    setIsEdit(false);
    setIsResultSmsForWinnerEditing(false);
  };

  useEffect(() => {
    if (isDelete) {
      setIsDelete(false);
    }
    fetchSmsSetting();
  }, [formikLinkSMS.isSubmitting, formikReminderSms.isSubmitting, isDelete, formikResultSms.isSubmitting, formikResultSmsForWinner.isSubmitting]);
  const fetchSmsSetting = async () => {
    try {
      const response: any = await getAllSmsSettings(dispatch, isMobile, navigate);
      console.log("response inside fetch sms setting", response);
      setData(response);
      console.log("response inside fetch ", response?.[0].reminderSmsContent);

      formikLinkSMS.setValues({
        inviteLinkSmsContent: response?.[0].inviteLinkSmsContent || "",
      });
      formikReminderSms.setValues({
        reminderSmsContent: response?.[0].reminderSmsContent || "",
      });
      formikResultSms.setValues({
        breefResultSmsContent: response?.[0].breefResultSmsContent || "",
      });
      formikResultSmsForWinner.setValues({
        breefResultSmsContentForWinner: response?.[0].breefResultSmsContentForWinner || "",
      });
      setId(response[0]?._id.toString());
    } catch (error) {
      console.log("Error", error)
    }
  };

  return (
    <Box>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          // marginRight: "30%",
          marginTop: "2%",
          marginBottom: "1%",
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: "6%",
          }}
        >
          {t("smsSetting.title")}
        </Typography>
      </div>
      <Typography
        variant="h5"
        fontWeight="bold"
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "6%",
          marginBottom: "2%",
        }}
      >
        {t("smsSetting.linkSms")}
      </Typography>
      <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "10px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginX: "10%",
            marginBottom: "5%",
            width: "100%",
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <TextField
                  autoFocus
                  required
                  margin="dense"
                  id="inviteLinkSmsContent"
                  name="inviteLinkSmsContent"
                  label={t("smsSetting.textField")}
                  type="text"
                  fullWidth
                  multiline
                  minRows={3}
                  sx={{ mt: 2 }}
                  variant="outlined"
                  onChange={formikLinkSMS.handleChange("inviteLinkSmsContent")}
                  value={formikLinkSMS.values.inviteLinkSmsContent}
                  error={
                    formikLinkSMS.touched.inviteLinkSmsContent &&
                    Boolean(formikLinkSMS.errors.inviteLinkSmsContent)
                  }
                  helperText={
                    formikLinkSMS.touched.inviteLinkSmsContent &&
                    formikLinkSMS.errors.inviteLinkSmsContent
                  }
                  disabled={!isEditing}
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
              {isEditing ? (
                <>
                  <Button
                    onClick={handleCancel}
                    variant="outlined"
                    sx={{
                      mr: 1,
                      color: "#ED670A",
                      borderColor: "#ED670A",
                      "&:hover": { borderColor: "#d55a07" },
                    }}
                  >
                    {t("updateTenant.t6")}
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ backgroundColor: "#ED670A", "&:hover": { backgroundColor: "#d55a07" } }}
                  >
                    {t("updateTenant.t7")}
                  </Button>
                </>
              ) : (
                <Button
                  onClick={handleOpenEdit}
                  //  type="submit"
                  variant="contained"
                  sx={{ backgroundColor: "#ED670A", "&:hover": { backgroundColor: "#d55a07" } }}
                >
                  {t("smsSetting.editLinkSms")}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </div>

      <Typography
        variant="h5"
        fontWeight="bold"
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "6%",
          marginBottom: "2%",
        }}
      >
        {t("smsSetting.resultSms")}
      </Typography>
      <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "10px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginX: "10%",
            marginBottom: "5%",
            width: "100%",
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <TextField
                  autoFocus
                  required
                  margin="dense"
                  id="breefResultSmsContent"
                  name="breefResultSmsContent"
                  label={t("smsSetting.textField")}
                  type="text"
                  fullWidth
                  multiline
                  minRows={3}
                  sx={{ mt: 2 }}
                  variant="outlined"
                  onChange={formikResultSms.handleChange("breefResultSmsContent")}
                  value={formikResultSms.values.breefResultSmsContent}
                  error={
                    formikResultSms.touched.breefResultSmsContent &&
                    Boolean(formikResultSms.errors.breefResultSmsContent)
                  }
                  helperText={
                    formikResultSms.touched.breefResultSmsContent &&
                    formikResultSms.errors.breefResultSmsContent
                  }
                  disabled={!isResultSmsEditing}
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
              {isResultSmsEditing ? (
                <>
                  <Button
                    onClick={handleResultSmsCancel}
                    variant="outlined"
                    sx={{
                      mr: 1,
                      color: "#ED670A",
                      borderColor: "#ED670A",
                      "&:hover": { borderColor: "#d55a07" },
                    }}
                  >
                    {t("updateTenant.t6")}
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ backgroundColor: "#ED670A", "&:hover": { backgroundColor: "#d55a07" } }}
                  >
                    {t("updateTenant.t7")}
                  </Button>
                </>
              ) : (
                <Button
                  onClick={handleResultSmsOpenEdit}
                  //  type="submit"
                  variant="contained"
                  sx={{ backgroundColor: "#ED670A", "&:hover": { backgroundColor: "#d55a07" } }}
                >
                  {t("smsSetting.editResultSms")}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </div>

      <Typography
        variant="h5"
        fontWeight="bold"
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "6%",
          marginBottom: "2%",
        }}
      >
        {t("smsSetting.resultSmsForWinner")}
      </Typography>
      <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "10px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            marginX: "10%",
            marginBottom: "5%",
            width: "100%",
          }}
        >
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <TextField
                  autoFocus
                  required
                  margin="dense"
                  id="breefResultSmsContentForWinner"
                  name="breefResultSmsContentForWinner"
                  label={t("smsSetting.textField")}
                  type="text"
                  fullWidth
                  multiline
                  minRows={3}
                  sx={{ mt: 2 }}
                  variant="outlined"
                  onChange={formikResultSmsForWinner.handleChange("breefResultSmsContentForWinner")}
                  value={formikResultSmsForWinner.values.breefResultSmsContentForWinner}
                  error={
                    formikResultSmsForWinner.touched.breefResultSmsContentForWinner &&
                    Boolean(formikResultSmsForWinner.errors.breefResultSmsContentForWinner)
                  }
                  helperText={
                    formikResultSmsForWinner.touched.breefResultSmsContentForWinner &&
                    formikResultSmsForWinner.errors.breefResultSmsContentForWinner
                  }
                  disabled={!isResultSmsForWinnerEditing}
                />
              </Grid>
            </Grid>

            <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
              {isResultSmsForWinnerEditing ? (
                <>
                  <Button
                    onClick={handleResultSmsForWinnerCancel}
                    variant="outlined"
                    sx={{
                      mr: 1,
                      color: "#ED670A",
                      borderColor: "#ED670A",
                      "&:hover": { borderColor: "#d55a07" },
                    }}
                  >
                    {t("updateTenant.t6")}
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ backgroundColor: "#ED670A", "&:hover": { backgroundColor: "#d55a07" } }}
                  >
                    {t("updateTenant.t7")}
                  </Button>
                </>
              ) : (
                <Button
                  onClick={handleResultSmsForWinnerOpenEdit}
                  //  type="submit"
                  variant="contained"
                  sx={{ backgroundColor: "#ED670A", "&:hover": { backgroundColor: "#d55a07" } }}
                >
                  {t("smsSetting.editResultSmsForWinner")}
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      </div>

      <Box>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            marginTop: "2%",
            marginBottom: "1%",
          }}
        >
          <Typography
            variant="h5"
            fontWeight="bold"
            style={{ display: "flex", alignItems: "center", marginLeft: "6%" }}
          >
            {t("smsSetting.reminderSms")}
          </Typography>
        </div>

        <div style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "10px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              marginX: "10%",
              marginBottom: "5%",
              width: "100%",
            }}
          >
            <Box component="form" onSubmit={handleSubmit}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="reminderSmsContent"
                    name="reminderSmsContent"
                    label={t("smsSetting.textField")}
                    type="text"
                    fullWidth
                    multiline
                    minRows={3}
                    sx={{ mt: 2 }}
                    variant="outlined"
                    onChange={formikReminderSms.handleChange("reminderSmsContent")}
                    value={formikReminderSms.values.reminderSmsContent}
                    error={
                      formikReminderSms.touched.reminderSmsContent &&
                      Boolean(formikReminderSms.errors.reminderSmsContent)
                    }
                    helperText={
                      formikReminderSms.touched.reminderSmsContent &&
                      formikReminderSms.errors.reminderSmsContent
                    }
                    disabled={!isReminderEditing}
                  />
                </Grid>
              </Grid>

              <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
                {isReminderEditing ? (
                  <>
                    <Button
                      onClick={handleReminderSmsCancel}
                      variant="outlined"
                      sx={{
                        mr: 1,
                        color: "#ED670A",
                        borderColor: "#ED670A",
                        "&:hover": { borderColor: "#d55a07" },
                      }}
                    >
                      {t("updateTenant.t6")}
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{ backgroundColor: "#ED670A", "&:hover": { backgroundColor: "#d55a07" } }}
                    >
                      {t("updateTenant.t7")}
                    </Button>
                  </>
                ) : (
                  <Button
                    onClick={handleReminderSmsOpenEdit}
                    //  type="submit"
                    variant="contained"
                    sx={{ backgroundColor: "#ED670A", "&:hover": { backgroundColor: "#d55a07" } }}
                  >
                    {t("smsSetting.editReminderSms")}
                  </Button>
                )}
              </Box>
              <Box>

              </Box>

            </Box>

          </Box>
        </div>

        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          marginLeft: '6%',
          marginBottom: '2rem'
        }}>
          <Typography
            variant="h5"
            fontWeight="bold"
          >
            {t("smsSetting.variables")}
          </Typography>
          <Box sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: '1rem',
            backgroundColor: '#f5f5f5',
            padding: '1.5rem',
            borderRadius: '8px',
          }}>
            {smsVariables.map((variable) => (
              <Box
                key={variable.key}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0.5rem',
                  justifyContent: 'space-between',
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'monospace',
                    fontWeight: 'medium',
                    color: '#ED670A',
                    marginRight: '8px',
                  }}
                >
                  |*{variable.key}*|
                </Typography>
                <Typography
                  sx={{
                    color: 'text.secondary',
                  }}
                >
                  {variable.description}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
